import { TrackingSDK } from './trackingSDK';

// 创建单例
const trackingSDK = new TrackingSDK();

// 导出单例
export default trackingSDK;

// 导出类型
export * from './types';

// 导出常量
export * from './constants';

// 导出工具函数
export * from './utils';

// 导出设备信息相关函数
export * from './device';

// 导出错误追踪相关函数
export * from './errorTracking';

// 导出页面追踪相关函数
export * from './pageTracking';

// 导出点击追踪相关函数
export * from './clickTracking';

// 导出SourceMap相关函数
export * from './sourceMap';
